<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">{{ accion }} Ticket</h5>
              </div>
              <div class="col-md-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Home</li>
                  <li class="breadcrumb-item active">Planta Externa</li>
                  <li class="breadcrumb-item active">Ticket</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-md-10">
                <div class="card">
                  <div class="card-body">
                    <!-- Cabecera como en la primera foto: logo | HOJA DE CARGA + LOMA JARILLOSA ESTE (2 líneas) | Remito -->
                    <div class="row align-items-center mb-4">
                      <div class="col-md-4">
                        <img
                          src="/img/image.png"
                          alt="Geopark"
                          class="img-fluid"
                          style="
                            max-height: 110px;
                            max-width: 280px;
                            width: auto;
                            height: auto;
                            object-fit: contain;
                          "
                        />
                      </div>
                      <div class="col-md-4 text-center">
                        <h4 class="mb-0 font-weight-bold">DESPACHO DE AGUA</h4>
                        <h5 class="mb-0 text-muted">
                          {{ form.numero_ticket || "Viaje Sin Ticket" }}
                        </h5>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group mb-0" v-if="accion == 'Editar'">
                          <label class="mb-0 mr-2">Estado:</label>
                          <span
                            class="w-25 badge"
                            :class="
                              form.estado == 1
                                ? 'bg-success'
                                : form.estado == 2
                                ? 'bg-info'
                                : 'bg-danger'
                            "
                            >{{
                              form.estado == 1
                                ? "Sin Imprimir"
                                : form.estado == 2
                                ? "Imprimido"
                                : "Anulado"
                            }}</span
                          >
                        </div>
                        <div class="form-group row mb-1">
                          <label class="col-5 col-form-label-sm text-right"
                            >Consecutivo No.
                          </label>
                          <div class="col-7">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.consecutivo"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-1">
                          <label class="col-5 col-form-label-sm text-right"
                            >Fecha:</label
                          >
                          <div class="col-7">
                            <input
                              type="date"
                              class="form-control form-control-sm"
                              v-model="form.fecha"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-1">
                          <label class="col-5 col-form-label-sm text-right"
                            >Hora Salida:</label
                          >
                          <div class="col-7">
                            <input
                              type="time"
                              class="form-control form-control-sm"
                              v-model="form.hora_salida"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Dos columnas verticales como el documento impreso (primera foto) -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Origen:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              :value="sitio_origen"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Empresa Transportadora:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              :value="transportadora"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Conductor:</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="nombreConductor"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Producto:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="tipo_producto"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Destino:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="sitio_destino"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Placa Cabezote:</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="vehiculo"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Placa Tanque:</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="remolque"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Cedula:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.cedula_conductor"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Numero Celular:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.numero_celular"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sección LABORATORIO: título centrado, filas 2 columnas -->
                    <div class="row border-top pt-3 mt-3">
                      <div class="col-md-6">
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Cloruros:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.cloruros"
                              :class="[
                                $v.form.cloruros.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >PH:</label
                          >
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.ph"
                              :class="[
                                $v.form.ph.$invalid ? 'is-invalid' : 'is-valid',
                              ]"
                            />
                          </div>
                        </div>
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Volumen (Bbls):</label
                          >
                          <div class="col-sm-8 d-flex align-items-center">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="form.volumen"
                              :class="[
                                $v.form.volumen.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-4 col-form-label col-form-label-sm"
                            >Sellos:</label
                          >
                          <div class="col-sm-8">
                            <span
                              class="badge badge-primary mr-1 mb-1"
                              v-for="(sello, index) in form.sellos"
                              :key="sello.id"
                            >
                              {{ sello.numero }}

                              <i
                                class="fas fa-times ml-1"
                                style="cursor:pointer"
                                @click="eliminarSello(index)"
                              ></i>
                            </span>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="numeroSello"
                              @keyup.enter="agregarSello"
                              :class="[form.sellos.length === 0 ? 'is-invalid' : 'is-valid']"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-5 pt-5 text-center">
                      <!-- Entrega -->
                      <div class="col-md-4">
                        <hr class="mt-4 mb-1" />

                        <h6>Entrega</h6>
                      </div>

                      <!-- Conductor -->
                      <div class="col-md-4">
                        <div class="mb-1">
                          {{ nombreConductor }}
                        </div>

                        <hr class="mt-0 mb-1" />

                        <h6>Conductor</h6>
                      </div>

                      <!-- Recibe -->
                      <div class="col-md-4">
                        <hr class="mt-4 mb-1" />

                        <h6>Recibe</h6>
                      </div>
                    </div>

                    <!-- Observaciones: dos líneas de entrada (como en la plantilla) -->
                    <div class="border-top pt-3 mt-3">
                      <div class="col-md-10">
                        <div class="form-group row mb-3">
                          <label
                            class="col-sm-2 col-form-label col-form-label-sm d-flex align-items-center"
                            >COMENTARIOS:</label
                          >
                          <div class="col-sm-10 d-flex align-items-center">
                            <input
                              type="textarea"
                              class="form-control form-control-sm"
                              v-model="form.observaciones"
                              placeholder="Observacion"
                              :class="[
                                $v.form.observaciones.$invalid
                                  ? 'is-invalid'
                                  : 'is-valid',
                              ]"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="row justify-content-center">
                      <button
                        type="button"
                        class="btn btn-secondary mr-2"
                        @click="back()"
                      >
                        <i class="fas fa-reply"></i> Volver
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="save()"
                        v-if="
                          $store.getters.can('plantaEx.ventanaOperaciones.guardarTicket') &&
                            !$v.form.$invalid &&
                            !form.numero_ticket
                        "
                      >
                        <i class="fas fa-save"></i> Guardar
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger ml-2"
                        @click="printPDF(form.id)"
                        v-if="$store.getters.can('plantaEx.ventanaOperaciones.imprimirTicket') && form.id || form.numero_ticket"
                      >
                        <i class="fas fa-file-pdf"></i> Imprimir Ticket
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";

export default {
  name: "PlantTicket",
  components: {
    Loading,
  },
  computed: {
    vehiculo() {
      return this.data?.vehiculo?.placa || this.form.vehiculo?.placa || "";
    },

    remolque() {
      return this.data?.remolque?.placa || this.form.remolque?.placa || "";
    },

    nombreConductor() {
      return (
        this.data?.conductor?.apellidos + " " + this.data?.conductor?.nombres ||
        this.form.conductor?.apellidos + " " + this.form.conductor?.nombres ||
        ""
      );
    },

    transportadora() {
      return (
        this.data?.transportadora?.razon_social ||
        this.form.transportadora?.razon_social ||
        ""
      );
    },

    sitio_origen() {
      return (
        this.data?.sitio_cargue?.nombre || this.form.sitioOrigen?.nombre || ""
      );
    },

    sitio_destino() {
      return (
        this.data?.sitio_descargue?.nombre ||
        this.form.sitioDestino?.nombre ||
        ""
      );
    },

    tipo_producto() {
      return (
        this.data?.tipo_producto?.nombre || this.form.tipoProducto?.nombre || ""
      );
    },
  },
  validations() {
    return {
      form: {
        tipo_producto: {
          required,
        },
        sitio_origen_id: {
          required,
        },
        sitio_destino_id: {
          required,
        },
        conductor_id: {
          required,
        },
        vehiculo_id: {
          required,
        },
        transportadora_id: {
          required,
        },
        remolque_id: {
          required,
        },
        observaciones: {
          required,
        },
        numero_celular: {
          required,
        },
        cloruros: {
          required,
        },
        ph: {
          required,
        },
        volumen: {
          required,
        },
        cedula_conductor: {
          required,
        },
      },
    };
  },
  data() {
    return {
      cargando: false,
      id: null,
      metodo: null,
      data: null,
      accion: null,
      numeroSello: "",
      form: {
        id: null,
        fecha: null,
        numero_ticket: null,
        viaje_id: null,
        tipo_producto: null,
        conductor_id: null,
        cedula_conductor: null,
        transportadora_id: null,
        vehiculo_id: null,
        remolque_id: null,
        sitio_origen_id: null,
        sitio_destino_id: null,
        observaciones: null,
        estado: 1,
        consecutivo: null,
        numero_celular: null,
        volumen: null,
        ph: null,
        cloruros: null,
        sellos: [],
      },
    };
  },

  methods: {
    async init() {
      this.accion = this.$route.params.accion;
      this.data = this.$route.params.viaje;

      if (this.data) {
        this.cargarDatosViaje(this.data);

        // verificar si ya existe un ticket para el viaje
        await this.buscarTicketPorViaje();
      }

      this.id = this.$route.params.id;
      if (this.accion === "Editar" && this.id) {
        this.metodo = "PUT";
      } else {
        this.metodo = "POST";
      }
    },

    async buscarTicketPorViaje() {
      try {
        const response = await axios.get(
          "/api/plant/tickets/viaje/" + this.form.viaje_id,
        );

        if (response.data) {
          // Ya existe un ticket
          this.metodo = "PUT";
          this.accion = "Editar";
          this.id = response.data.id;

          this.getData(response.data);
        } else {
          // No existe
          this.metodo = "POST";
          this.accion = "Crear";
        }
      } catch (e) {
        this.metodo = "POST";
        this.accion = "Crear";
      }
    },

    printPDF(ticket_id) {
      axios
        .get("/api/plant/ticket/pdf/" + ticket_id)
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          window.open(data.url, "_blank");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    cargarDatosViaje(viaje) {
      this.form.viaje_id = viaje.id;
      this.form.tipo_producto = viaje.tipo_producto_id;
      this.form.conductor_id = viaje.conductor_id;
      this.form.remolque_id = viaje.remolque_id;
      this.form.sitio_origen_id = viaje.sitio_cargue_id;
      this.form.sitio_destino_id = viaje.sitio_descargue_id;
      this.form.transportadora_id = viaje.transportadora_id;
      this.form.vehiculo_id = viaje.vehiculo_id;
      this.form.cedula_conductor = viaje.conductor?.numero_documento;
      this.form.numero_celular = viaje.conductor?.celular_principal;
    },

    getData(ticket) {
      this.form.id = ticket.id;
      this.form.numero_ticket = ticket.numero_ticket;
      this.form.consecutivo = ticket.consecutivo;
      this.form.fecha = ticket.fecha;
      this.form.hora_salida = ticket.hora_salida;
      this.form.observaciones = ticket.observaciones;
      this.form.cloruros = ticket.cloruros;
      this.form.ph = ticket.ph;
      this.form.volumen = ticket.volumen_bps;
      this.form.estado = ticket.estado;
      this.form.sellos = ticket.sellos;
    },

    save() {
      this.cargando = true;

      axios({
        method: this.metodo,
        url: "/api/plant/tickets",
        data: this.form,
      })
        .then((response) => {
          this.cargando = false;

          this.getData(response.data);

          this.accion = "Editar";
          this.id = response.data.id;

          this.$swal({
            icon: "success",
            title: "El ticket fue guardado exitosamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .catch((e) => {
          this.cargando = false;

          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + e.response.data.message,
          });
        });
    },

    eliminarSello(index) {
      this.form.sellos.splice(index, 1);
    },

    async agregarSello() {
      if (!this.numeroSello) return;

      try {
        const response = await axios.get(
          "/api/plant/sellos/buscar/" + this.numeroSello,
        );

        if (response.data) {
          // evitar repetir
          if (!this.form.sellos.some((s) => s.id == response.data.id)) {
            this.form.sellos.push(response.data);
          }

          this.numeroSello = "";
        } else {
          this.crearSello();
        }
      } catch (e) {
        this.crearSello();
      }
    },

    async crearSello() {
      const respuesta = await this.$swal({
        title: "Sello no encontrado",
        text: "¿Desea crearlo?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      });

      if (!respuesta.isConfirmed) return;

      const response = await axios.post("/api/plant/sellos/crear", {
        numero: this.numeroSello,
        sitio_id: this.$route.params.viaje.sitio_cargue.id,
      });

      this.form.sellos.push(response.data);

      this.numeroSello = "";
    },

    back() {
      let sitio_id, sitio_type, tipo_control;
      sitio_id = this.$route.params.sitio_id;
      sitio_type = this.$route.params.sitio_type;
      tipo_control = this.$route.params.tipo_control;

      const nuevaRuta = `/plantaExterna/VentanaOperaciones/${sitio_id}/${sitio_type}/${tipo_control}`;

      if (this.$route.path !== nuevaRuta) {
        this.$router.replace({
          path: nuevaRuta,
          params: {
            recargar: true,
          },
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
